// Generated by `just flag-gen` from backend/web/src/feature-access/feature-registry.ts. Do not edit.

export const FEATURE_KEYS = [
  'boards',
  'chat',
  'digital_coworker',
  'workflows',
  'data_catalog',
  'graph_editor',
  'tag_mapping',
  'knowledge_graph',
  'expert_knowledge',
  'connectors',
  'plc_parser',
  'agent_calls',
  'help_agent',
] as const
